export function getThemeLogoUrl(theme, defaultLogo) {
    
    if (!theme || theme === 'undefined' || !theme.logoPath || theme.logoPath === null || typeof theme.logoPath === 'undefined') {
        return defaultLogo; // TODO: Retourner une image de placeholder
    }

    if (theme.logoPath.startsWith('http')) {
        return theme.logoPath;
    }

    return process.env.VUE_APP_API +  theme.logoPath;
}

/**
 * Méthode permettant de savoir si le theme a été ajouté après la dernière connextion de l'utilisateur
 * @param {object} user Utilisateur courant
 * @param {object} theme Theme courante
 * @returns 
 */
export function userLastTheme(user, theme) {
    const createTheme = theme.createdAt;
    const previousConnectionUser = user.previousConnection;
  
    if (previousConnectionUser === null || (createTheme > previousConnectionUser)) {
      return true;
    }
  
    return false;
  }